<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <span>{{full_name}}</span>
      <img :src="user_picture" class="img-avatar" alt="www.fibernode.com" />
      <b-badge
        v-if="itemsCount > 0"
        style="margin-left: 35px"
        pill
        variant="danger"
      >{{ itemsCount }}</b-badge>
    </template>\
    <template slot="dropdown">
      <!--      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>-->
      <!--      <b-dropdown-item><i class="fa fa-bell-o" /> Updates-->
      <!--        <b-badge variant="info">{{ itemsCount }}</b-badge>-->
      <!--      </b-dropdown-item>-->

      <b-dropdown-item to="/base/profile">
        <i class="fa fa-user" /> Profile Settings
      </b-dropdown-item>

      <!-- <b-dropdown-item to="/base/inbox">
        <i class="fa fa-envelope-o" /> Inbox
        <b-badge v-if="itemsCount > 0" variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item> -->
      <!--      <b-dropdown-item><i class="fa fa-tasks" /> Tasks-->
      <!--        <b-badge variant="danger">{{ itemsCount }}</b-badge>-->
      <!--      </b-dropdown-item>-->
      <!--      <b-dropdown-item><i class="fa fa-comments" /> Comments-->
      <!--        <b-badge variant="warning">{{ itemsCount }}</b-badge>-->
      <!--      </b-dropdown-item>-->
      <!--      <b-dropdown-header-->
      <!--        tag="div"-->
      <!--        class="text-center">-->
      <!--        <strong>Settings</strong>-->
      <!--      </b-dropdown-header>-->
      <!--      <b-dropdown-item><i class="fa fa-user" /> Profile</b-dropdown-item>-->
      <!--      <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item>-->
      <!--      <b-dropdown-item><i class="fa fa-usd" /> Payments-->
      <!--        <b-badge variant="secondary">{{ itemsCount }}</b-badge>-->
      <!--      </b-dropdown-item>-->
      <!--      <b-dropdown-item><i class="fa fa-file" /> Projects-->
      <!--        <b-badge variant="primary">{{ itemsCount }}</b-badge>-->
      <!--      </b-dropdown-item>-->
      <!--      <b-dropdown-divider />-->
      <!--      <b-dropdown-item><i class="fa fa-shield" /> Lock Account</b-dropdown-item>-->
      <b-dropdown-item @click="logout()">
        <i class="fa fa-lock" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import router from "../router";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    router,
    AppHeaderDropdown
  },
  data: () => {
    return {
      full_name: "",
      itemsCount: 0,
      user_picture: "",
      locationParam: null
    };
  },
  methods: {
    getCount() {
      let params = {};
      params = {
      };
      this.$http
        .get("api/inbox/getCount.php", {
          params
        })
        .then(
          res => {
            this.itemsCount = res.data.records[0].count;
          },
          err => {
            console.log(err);
          }
        );
    },
    logout() {
      localStorage.clear();
      window.location.href = process.env.VUE_APP_TRACKER_URL
    }
  },
  mounted() {
    this.user_picture = localStorage.getItem("viavi_user_picture");

    this.locationParam = localStorage.getItem("viavi_user");
    this.full_name = localStorage.getItem("viavi_full_name");

    this.getCount();
  }
};
</script>
